const _version = "2.15.13"
function version() {
    return _version
}
export default version
